import { useState } from 'react';
import { monthlyCost } from '../../utils/onboarding';
import styles from './Onboarding.module.css';

const FEATURES = [
  'Unlimited projects & milestones',
  'Team scheduling & timesheets',
  'Leads pipeline & directory',
  'Leave management',
  'Reports & Excel export',
  'Email support',
];

const rand = (n) => `R${n.toLocaleString('en-ZA')}`;

export default function TrialStep({ invited, pricing, trialEndsAt, onStart, onBack }) {
  const [resources, setResources] = useState(0);
  const [busy, setBusy] = useState(false);

  const permanent = 1 + invited.permanent;
  const contractors = invited.contractor;
  const calculated = (permanent + contractors) * pricing.per_user + (contractors + resources) * pricing.per_resource;
  const total = monthlyCost({ permanent, contractors, resources }, pricing);

  const start = async () => {
    setBusy(true);
    await onStart();
    setBusy(false);
  };

  return (
    <div>
      <div className={styles.costCard}>
        <div className={styles.costHead}>
          <small>YOUR MONTHLY COST AFTER TRIAL</small>
          <strong>{rand(total)} / month</strong>
          {trialEndsAt && (
            <span className={styles.costEnds}>
              Trial ends {new Date(trialEndsAt).toLocaleDateString('en-ZA', { day: 'numeric', month: 'short', year: 'numeric' })}
            </span>
          )}
        </div>
        <div className={styles.costRow}>
          <div>
            Users
            <small>{permanent} permanent (including you) · {contractors} contractor{contractors === 1 ? '' : 's'} · {rand(pricing.per_user)} each</small>
          </div>
          <strong>{rand((permanent + contractors) * pricing.per_user)}</strong>
        </div>
        <div className={styles.costRow}>
          <div>
            Resources
            <small>Contractors, vehicles, tools, rooms · {rand(pricing.per_resource)} each</small>
          </div>
          <div>
            <span className={styles.stepper2}>
              <button type="button" aria-label="Fewer resources" onClick={() => setResources((r) => Math.max(0, r - 1))}>−</button>
              <span aria-live="polite">{resources}</span>
              <button type="button" aria-label="More resources" onClick={() => setResources((r) => r + 1)}>+</button>
            </span>
            <strong>{rand((contractors + resources) * pricing.per_resource)}</strong>
          </div>
        </div>
        {calculated < pricing.minimum && (
          <div className={styles.costRow}><small>A minimum of {rand(pricing.minimum)} a month applies.</small></div>
        )}
      </div>

      <ul className={styles.features}>
        {FEATURES.map((f) => <li key={f}>{f}</li>)}
      </ul>
      <p className={styles.note}>No card now. We'll remind you 3 days before the trial ends.</p>

      <div className={styles.actions}>
        <button type="button" className={styles.link} onClick={onBack}>← Back</button>
        <button type="button" className={styles.primaryButton} onClick={start} disabled={busy}>
          {busy ? 'Starting…' : 'Start free trial'}
        </button>
      </div>
    </div>
  );
}
